import './assets/main.css'
import './assets/ui.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { initSentry } from './sentry'
import { i18n, resolveLocale, setLocale } from './i18n'
import { loadTelegramSdk } from './telegramSdk'
import { ready, expand, applyThemeParams, getTelegramLanguage } from './telegramWebApp'

// The SDK is only fetched inside Telegram and has to be there before the first call below.
void loadTelegramSdk().then(() => {
  // Apply the Telegram theme before mount so there's no light/dark flash of the fallback palette.
  applyThemeParams()
  ready()
  expand()

  const app = createApp(App)

  initSentry(app, router)

  // Telegram's client language until the saved choice arrives with the user's settings (see App.vue).
  setLocale(resolveLocale(null, getTelegramLanguage()))

  app.use(i18n)
  app.use(createPinia())
  app.use(router)

  app.mount('#app')

  document.title = import.meta.env.VITE_APP_TITLE || 'sync_todo'
})
